import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=e4731dd0"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4731dd0')) {
      api.createRecord('e4731dd0', component.options)
    } else {
      api.reload('e4731dd0', component.options)
    }
    module.hot.accept("./Welcome.vue?vue&type=template&id=e4731dd0", function () {
      api.rerender('e4731dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Welcome.vue"
export default component.exports